///////////////////////////////////////////////////////////////////////////////////////
//                          Copyright (c) 2020 - 2021
//                           Coyote Logistics L.L.C.
//                         All Rights Reserved Worldwide
//
//WARNING:  This program (or document) is unpublished, proprietary
//property of Coyote Logistics L.L.C. and is to be maintained in strict confidence.
//Unauthorized reproduction, distribution or disclosure of this program
//(or document), or any program (or document) derived from it is
//prohibited by State and Federal law, and by local law outside of the U.S.
///////////////////////////////////////////////////////////////////////////////////////

import Avatar from "../components/Avatar";
import { status, userTitle } from "./types";

export const getActiveBidAvatars = bid => {
  const avatars = [];
  for (let mode of bid.modes) {
    if (
      mode.status !== status.pending &&
      mode.status !== status.rejected &&
      mode.modeOwner &&
      mode.modeOwner.userId !== bid.mainSalesRep.userId
    ) {
      let modeOwnerInitials = mode.modeOwner.fullName
        .split(" ")
        .map(x => x.substring(0, 1))
        .join("");
      avatars.push(
        <Avatar
          alt={mode.modeOwner.fullName}
          className={`team-member align-bottom inline-block mb-0 mr-2`}
          data-testid="owned-mode-avatar"
          imageSource={mode.modeOwner.profilePicture}
          key={`${bid.bidId} ${mode.mode}`}
          size={20}
          tooltipContent={
            <div>
              {mode.modeOwner.fullName}
              <br />
              {userTitle[mode.modeOwner.userRole]}
            </div>
          }
          textContent={modeOwnerInitials}
          fontSize={8}
        />
      );
    }
  }

  let salesRepInitials = bid.mainSalesRep.fullName
    .split(" ")
    .map(x => x.substring(0, 1))
    .join("");

  avatars.push(
    <Avatar
      alt={bid.mainSalesRep.fullName}
      className="team-member align-bottom inline-block mb-0 mr-2"
      data-testid="sales-rep-avatar"
      imageSource={bid.mainSalesRep.profilePicture}
      key={`${bid.bidId} ${bid.deadlineDateUTC}`}
      size={20}
      tooltipContent={
        <div>
          {bid.mainSalesRep.fullName}
          <br />
          {userTitle[bid.mainSalesRep.userRole]}
        </div>
      }
      textContent={salesRepInitials}
      fontSize={8}
    />
  );

  bid.bidSubscribers &&
    bid.bidSubscribers.map(s => {
      return (
        s.userId !== bid.mainSalesRep.userId &&
        avatars.push(
          <Avatar
            alt={s.fullName}
            className="subscribers align-bottom inline-block mb-0 mr-2"
            data-testid={`${s.userId}-subscriber-avatar`}
            imageSource={s.profilePicture}
            key={`${s.userId} ${s.fullName}`}
            size={20}
            tooltipContent={<div>{s.fullName}</div>}
            textContent={`${s["firstName"][0]}${s["lastName"][0]}`}
            fontSize={8}
          />
        )
      );
    });

  return avatars;
};

export default getActiveBidAvatars;
